import styled from 'styled-components';

export const alerte = styled.div` 
display:flex;
justify-content: center ;
position: fixed ;
top: 200px;
left: 0px ;
right: 0px;
font-weight:600;
z-index: 2;

.alertar{
  display: flex ;
  flex-direction: column ;
  background-color: white ;
  border-radius: 2px;
  box-shadow: 0px 0px 50px black;
  justify-content: center ;
  padding: 10px ;

  label{
  display: flex ;
  color: black ;
  font-size: 13px;
  justify-content: center ;
  text-align: center ;
}

}

button{
  display: flex ;
  width: 50px ;
  border-radius: 2px;
  padding-top: 3px ;
  cursor:pointer ;
  border:none ;
  justify-content: center ;
  font-weight:700;
  background-color:#e2ecff
}
.simnao{
  display: flex ;
  width:100% ;
  justify-content: end ;
  margin-top: 7px;
  color: white ;
  font-size: 15px;

}
.nao{
  color:#f0433d ;
  &:hover{
  background-color:#f0433d;
  color: white ;
}
}
.sim{
  color:#3881ff ;
  margin-left: 10px ;
  &:hover{
  background-color:#16b992;
  color: white ;
}
}

.alertaJaExiste{
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  justify-content: center;
  padding: 30px;
  min-width: 350px;
  position: relative;

  .header{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 40px;
  }

  .titulo{
    font-size: 18px;
    font-weight: 700;
    color: #2c3e50;
    text-align: center;
    margin-bottom: 15px;
    line-height: 1.4;
  }

  .nomeCliente{
    font-size: 16px;
    color: #34495e;
    text-align: center;
    margin-bottom: 25px;
    padding: 12px;
    background-color: #ecf0f1;
    border-radius: 5px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .footer{
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
  }
}

.btnFechar{
  background: none !important;
  border: none !important;
  font-size: 24px;
  color: #bdc3c7;
  cursor: pointer;
  padding: 0 !important;
  width: auto !important;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover{
    color: #e74c3c;
    transform: scale(1.1);
  }
}

.btnOk{
  background-color: #27ae60 !important;
  color: white !important;
  width: 80px !important;
  border-radius: 5px !important;
  padding: 8px !important;
  font-weight: 700 !important;
  transition: all 0.3s ease;

  &:hover{
    background-color: #229954 !important;
    transform: translateY(-2px);
    box-shadow: 0px 4px 12px rgba(39, 174, 96, 0.3);
  }

  &:active{
    transform: translateY(0);
  }
}
`

export const alerteExcluir = styled.div` 
display:flex;
justify-content: center ;
height:100px ;
position: absolute ;
left: 20vw ;
font-weight:600;
z-index: 10;

.alertar{
  display: flex ;
  flex-direction: column ;
  background-color: white ;
  border-radius: 2px;
  box-shadow: 0px 0px 50px black;
  justify-content: center ;
  padding: 10px ;

  label{
  display: flex ;
  color: black ;
  font-size: 13px;
  justify-content: center ;
  text-align: center ;
}

}

button{
  display: flex ;
  width: 50px ;
  border-radius: 2px;
  padding-top: 3px ;
  cursor:pointer ;
  border:none ;
  justify-content: center ;
  font-weight:700;
  background-color:#e2ecff
}
.simnao{
  display: flex ;
  width:100% ;
  justify-content: end ;
  margin-top: 7px;
  color: white ;
  font-size: 15px;

}
.nao{
  color:#f0433d ;
  &:hover{
  background-color:#f0433d;
  color: white ;
}
}
.sim{
  color:#3881ff ;
  margin-left: 10px ;
  &:hover{
  background-color:#16b992;
  color: white ;
}
}

.alertaJaExiste{
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  justify-content: center;
  padding: 30px;
  min-width: 350px;
  position: relative;

  .header{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 40px;
  }

  .titulo{
    font-size: 18px;
    font-weight: 700;
    color: #2c3e50;
    text-align: center;
    margin-bottom: 15px;
    line-height: 1.4;
  }

  .nomeCliente{
    font-size: 16px;
    color: #34495e;
    text-align: center;
    margin-bottom: 25px;
    padding: 12px;
    background-color: #ecf0f1;
    border-radius: 5px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .footer{
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
  }
}

.btnFechar{
  background: none !important;
  border: none !important;
  font-size: 24px;
  color: #bdc3c7;
  cursor: pointer;
  padding: 0 !important;
  width: auto !important;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover{
    color: #e74c3c;
    transform: scale(1.1);
  }
}

.btnOk{
  background-color: #27ae60 !important;
  color: white !important;
  width: 80px !important;
  border-radius: 5px !important;
  padding: 8px 15px !important;
  font-weight: 700 !important;
  transition: all 0.3s ease;

  &:hover{
    background-color: #229954 !important;
    transform: translateY(-2px);
    box-shadow: 0px 4px 12px rgba(39, 174, 96, 0.3);
  }

  &:active{
    transform: translateY(0);
  }
}
`